import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'src/redux/reducer';

// this adds support to Redux devtools and will simply fallback safely
// if the extension is not installed. As also mentioned on the official docs
// https://github.com/zalmoxisus/redux-devtools-extension#usage
//
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const global: any = typeof window !== 'undefined' ? window : undefined;
let composer = compose;

if (global && global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composer = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

export const store = () => global.__NEXT_REDUX_STORE__;
export const makeStore = state => createStore(rootReducer, state, composer(applyMiddleware(thunk)));
